import {useCallback} from 'react';
import useUpdatePayinSessionMutation from 'src/api/graphql/useUpdatePayinSessionMutation';
import {getStore} from 'src/v2/state/store';
import {useSessionContext} from 'src/state/usePayinSessionContext';

interface MiradorIds {
  muid: string | null;
  sid: string | null;
}

export const useUpdateSessionMiradorIds = (): ((
  miradorIds: MiradorIds,
) => void) => {
  const store = getStore();
  const sessionContext = useSessionContext();
  const [updatePayinSessionMutation] = useUpdatePayinSessionMutation();
  const sessionId = store.useSelector((state) => state.id);
  const clientSecret = store.useSelector((state) => state.clientSecret);

  const updateSession = useCallback(
    (miradorIds: MiradorIds) => {
      if (sessionContext.mode === 'pay') {
        updatePayinSessionMutation({
          variables: {
            input: {
              client_secret: clientSecret,
              crypto_payin_session: sessionId,
              mirador_params: {
                muid: miradorIds.muid,
                suid: miradorIds.sid,
              },
            },
          },
        });
      }
    },
    [sessionId, clientSecret, updatePayinSessionMutation, sessionContext.mode],
  );

  return updateSession;
};
